const dataAnalyticsCareers = [

    {
        id: 35,
        slug: "data-analyst",
        title: "Data Analyst",
        department: "Data Analytics",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Collect, clean, and organize datasets from multiple sources",
                "Prepare dashboards and reports using analytics tools",
                "Perform basic data analysis and trend identification",
                "Support research and accounting teams with data processing",
                "Maintain structured data files and reporting templates"
            ],
            skills: [
                "Excel and spreadsheet analysis",
                "Basic data visualization tools (Power BI, Tableau)",
                "Data cleaning and formatting",
                "Attention to detail"
            ],
            experience: ["0–2 years"],
            education: [
                "Bachelor’s degree in Data Analytics, Statistics, Computer Science, Economics, or related field"
            ]
        }
    },

    {
        id: 36,
        slug: "senior-data-analyst",
        title: "Senior Data Analyst",
        department: "Data Analytics",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Analyze large datasets and generate insights",
                "Develop dashboards and automated reports",
                "Support business teams with data-driven analysis",
                "Improve data processes and reporting structures",
                "Review and validate analytical outputs"
            ],
            skills: [
                "Advanced Excel and data analysis",
                "Data visualization tools (Power BI, Tableau)",
                "SQL or basic database querying",
                "Analytical problem solving"
            ],
            experience: ["2–4 years"],
            education: [
                "Bachelor’s or Master’s degree in Data Analytics, Statistics, Computer Science, Economics, or related field"
            ]
        }
    },

    {
        id: 37,
        slug: "analytics-manager",
        title: "Analytics Manager",
        department: "Data Analytics",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Manage analytics projects and reporting workflows",
                "Design dashboards and reporting frameworks",
                "Coordinate with research and accounting teams on analytics needs",
                "Ensure accuracy and quality of analytical outputs",
                "Improve automation and data processing efficiency"
            ],
            skills: [
                "Data analytics and reporting",
                "Dashboard design and visualization",
                "Team coordination and project management",
                "Data interpretation and insight generation"
            ],
            experience: ["4+ years"],
            education: [
                "Bachelor’s or Master’s degree in Data Analytics, Statistics, Computer Science, Economics, or related field"
            ]
        }
    }

];

export default dataAnalyticsCareers;
